import React, { useMemo, useEffect } from 'react';
import classNames from 'classnames';

import useImage from '../hooks/useImage';

import Title from '../components/Title';
import Information from '../components/Information';

type FrameProps = {
  children: React.ReactNode;
  mobile: boolean;
};
/**
 * @description Application 전체를 Header, Body, Footer로 나누는 Latout 컴포넌트
 * @property {React.ReactNode} children Body에 들어갈 Content Component
 * @property {boolean} mobile 모바일 브라우저인지 여부
 */
function Frame({ children, mobile }: FrameProps) {
  // Image Redux사용
  const { image, check, onHeaderIcon } = useImage();

  // mobile인지에 따라 Header와 Footer에 Class를 추가하여 Style 변경
  const headerClass = useMemo(
    () => classNames('header container', { mobile }),
    [mobile],
  );
  const footerClass = useMemo(
    () => classNames('footer container', { mobile }),
    [mobile],
  );

  // 고해상도 이미지 랜더링
  useEffect(() => {
    if (!check(image.header_icon)) onHeaderIcon();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={headerClass}>
        <Title icon={image.header_icon} alt="Logo" />
      </div>
      <div className="body">{children}</div>
      <div className={footerClass}>
        <Information
          ceo = "(주)코인플러그 대표이사 어준선"
          address="경기도 성남시 분당구 판교역로 146번길 20, Office H, 11층"
          support="고객지원 | metapass@coinplug.com"
          copy="Copyright &copy; Coinplug Inc. All rights reserved."
        />
      </div>
    </>
  );
}

export default Frame;
